$(document).ready(function () {

    // Add the User Agent to the <html> element
    var doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);

    /* product back flip */
    $(".product-flip").click(function () {
        $(this).closest('.thumbnail').find(".img-front").toggleClass("hidden");
        $(this).closest('.thumbnail').find(".img-back").toggleClass("hidden");
        return false;
    });

    /* modal back flip */
    $(".modal-flip").click(function () {
        $(this).closest('.modal-body').find(".img-front").toggleClass("hidden");
        $(this).closest('.modal-body').find(".img-back").toggleClass("hidden");
        return false;
    });


    /**
     * Disable double press of submit buttons
    */

    $('form').submit(function(e){
      if( $(this).hasClass('form-submitted') ){
        e.preventDefault();
        return;
      }
      $(this).addClass('form-submitted');
    });


    /*
     * date pickers
     */
    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        orientation: "top"
    });

    $('.datepicker_social').datepicker({
        format: 'dd/mm/yyyy',
        startDate: moment().add(7, 'days').format("DD-MM-YYYY")
    });

    $('.datepicker_deadline').datepicker({
        format: 'dd/mm/yyyy',
        startDate: moment().add(7, 'days').format("DD-MM-YYYY")
    });


    $('.datepicker_campaign_start').datepicker({
        format: 'dd/mm/yyyy',
        startDate: moment().add(6, 'weeks').format("DD-MM-YYYY")
    });


    $('.datepicker_campaign_end').datepicker({
        format: 'dd/mm/yyyy',
        startDate: moment().add(6, 'weeks').format("DD-MM-YYYY")
    });


    /*
     * date pickers (Disabling dates in the past and dependent disabling)
     */
    var nowTemp = new Date();
    var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

    /*
     * Tooltips
     */
    $('[data-toggle="tooltip"]').tooltip();

    $('.datepicker_end').datepicker({
        startDate: now,
        format: 'dd/mm/yyyy'
    });



    var checkin = $('.datepicker_start').datepicker({
        startDate: now,
        format: 'dd/mm/yyyy'
    }).on('changeDate', function (ev) {

        var endDate = new Date(ev.date);

        var next_year = endDate.getFullYear() + 1;

        endDate.setFullYear(next_year)

        $('.datepicker_end').datepicker("setDate", endDate);

        $('.datepicker').hide();

        $(this).parent().parent().find('.datepicker_end')[0].focus();

    });


    // Artwork Request Dimension Preset
    $("#dimension_preset").change(function() {
        var selected = $(this).find('option:selected');
        var width = selected.data('width');
        var height = selected.data('height');
        var units = selected.data('units');

        $("#dimension_height").val(height);
        $("#dimension_width").val(width);
        $("#dimension_units").val(units);

    });


    // Bootstrap collapse/toggle
    $("[type=button]").button();
    $("[type=button]").click(function () {
        $(this).button('toggle');
        if ($(this).text() === "View") {
            $(this).button('open');
        }
        else {
            $(this).button('reset');
        }
    });

    // Flash navbar (wait for 2 seconds)
    setTimeout(function () {

        // fade all alerts out for 500ms
        $("#alert-flash-navbar").fadeOut(500, function () {

            // obliterate the alert
            $(this).remove();

        });

    }, 2000);


    // operations-team-store selection
    $('input.operations-team-store-selector').change(function () {
        if ($(this).is(":checked")) {
            $.post("/ajax/operations-team_set_store", {operations_team_id: $(this).data('operations-team-id'), store_id: $(this).data('store-id')});
        } else {
            $.post("/ajax/operations_team_unset_store", {store_id: $(this).data('store-id')});
        }
    });


    // dataTables
    if ($('.datatable').length > 0) {
        $('.datatable').dataTable({
            "aaSorting": [], /* Disable initial sort */
            "bStateSave": true, /* save sort state to cookie */
            "aoColumnDefs": [
                {
                    "bSortable": false
                }
            ],
            "iDisplayLength": 100,
            "oLanguage": {
                "sLengthMenu": "View _MENU_ per page",
                "sSearch": "",
                "sLoadingRecords": '<i class="fa fa-circle-o-notch fa-spin"></i> Loading...',
                "sProcessing": '<i class="fa fa-circle-o-notch fa-spin"></i> Processing...'
            }
        });
    }

    $('.datatable-orders').dataTable({
        "ajax": "/orders/ajax_search",
        "processing": true,
        "serverSide": true,
        "searchDelay": 500,
    });


    $('.datatable-social, .datatable-campaign, .datatable-artwork, .datatable-resource-booking').dataTable({
        "aaSorting": [], /* Disable initial sort */
        "bStateSave": true, /* save sort state to cookie */
        "iDisplayLength": 100,
        "oLanguage": {
            "sLengthMenu": "View _MENU_ per page",
            "sSearch": "",
            "sLoadingRecords": '<i class="fa fa-circle-o-notch fa-spin"></i> Loading...',
            "sProcessing": '<i class="fa fa-circle-o-notch fa-spin"></i> Processing...'
        }
    });


    $('div.dataTables_filter input').addClass('form-control input-sm').attr("placeholder", "Filter...");
    $('div.dataTables_paginate.paging_bootstrap ul').addClass('pagination-sm');




    // Modal confirmation handler
    $('.btn-modal-confirm').click(function () {
        // get confirmation title
        var modal_title = $(this).attr('modal-title');
        // get confirmation header
        var modal_header = $(this).attr('modal-header');
        // get confirmation text
        var modal_text = $(this).attr('modal-text');
        // get confirmation button class
        var modal_btn_class = $(this).attr('modal-btn-class');
        // get confirmation button label
        var modal_btn_label = $(this).attr('modal-btn-label');
        // get show comments flag
        var modal_show_comments = $(this).attr('modal-show-comments');

        // toggle the modal comments
        if(modal_show_comments == 'true') {
            $("#modal_comments").show();
        }
        else {
            $("#modal_comments").hide();
        }

        // set confimation title
        $('#modal_dialog').find('#modal_dialog_title').text(modal_title);
        // set confimation header
        $('#modal_dialog').find('#modal_dialog_header').text(modal_header);
        // set confimation text
        $('#modal_dialog').find('#modal_dialog_text').text(modal_text);
        // set confimation button class
        $('#modal_dialog').find('.btn-modal-dialog').addClass(modal_btn_class);
        // set confimation button label
        $('#modal_dialog').find('#modal_dialog_btn_label').val(modal_btn_label);
        // set delete url
        $('#modal_dialog').find('#modal_form').attr('action', $(this).attr('href'));
        // show modal
        $('#modal_dialog').modal();
        // cancel delete
        return false;
    });



    $('#addProductModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget) // Button that triggered the modal
        var product_id = button.data('product-id') // Extract info from data-* attributes

        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this)

        // we have to wrap this stuff inside an if(product_id) because
        // the show.bs.modal event is used by both the original modal and also
        // the datetime picker. when you open a timepicker inside the modal
        // this event is retriggered but with the data attributes missing
        if(product_id) {

            modal.find('.modal-theme-container').show();
            modal.find('.modal-competition-container').show();

            var themed = button.data('themed');
            var is_competition = button.data('is-competition');

            // hide the theme container if this product doesn't need a theme
            if(themed != true) {
                modal.find('.modal-theme-container').hide();
            }

            // hide the competition container if product doesn't contain competition
            if(is_competition != true) {
                modal.find('.modal-competition-container').hide();
            }

           // modal.find('.modal-title').text('Add product to cart ' + product_id)
            modal.find('.product-id').val(product_id);

        }

    });



    $("#add_to_cart_form").submit(function (event) {

        // only validate competition form when the competition details are shown
        if($("#add_to_cart_form").find(".modal-competition-container").is(":visible")) {

            // remove any existing errors when you try to re-submit
            $("#add_to_cart_form").find(".has-error").removeClass("has-error");

            if($("#tnc_commencement_date").val() == '') {
                console.log('missing tnc_commencement_date');
                $("#tnc_commencement_date").parent().addClass("has-error");
                event.preventDefault();
            }

            else if($("#tnc_conclusion_date").val() == '') {
                $("#tnc_conclusion_date").parent().addClass("has-error");
                event.preventDefault();
            }

            else if($("#tnc_draw_date").val() == '') {
                $("#tnc_draw_date").parent().addClass("has-error");
                event.preventDefault();
            }

            else if($("#tnc_price_rrp").val() == '') {
                $("#tnc_price_rrp").parent().addClass("has-error");
                event.preventDefault();
            }

            else if(isNaN($("#tnc_price_rrp").val())) {
                alert('Please enter a valid number for RRP.');
                $("#tnc_price_rrp").parent().addClass("has-error");
                event.preventDefault();
            }

            else if($("#tnc_prize_description").val() == '') {
                $("#tnc_prize_description").parent().addClass("has-error");
                event.preventDefault();
            }

            // no validation errors so we can submit
            else {

                $("#add_to_cart_form").unbind("submit").submit();

            }

        }

    });




    // stupid fix

    // short delay for this stupid fix - i has reasons


    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    // if (msie > 0) {

    //     setTimeout(function() {

    //       fix_it_noaw();
    //     })

    //     $(window).resize(function() {
    //       fix_it_noaw();
    //     });
    // }


    $.each($(".file-upload-container"), function (index, uploadContainer) {

        // fine upload
        var fineuploader = $(uploadContainer).find(".fine-uploader").fineUploader({
            request: {
                endpoint: '/files/upload',
                params: {
                    type: $(uploadContainer).data("type"),
                    s3_acl: $(uploadContainer).data("s3-acl"),
                    multiple: $(uploadContainer).data("multiple"),
                    usage_type: $(uploadContainer).data("usage-type")
                }
            },
            uploaderType: 'basic',
            multiple: $(uploadContainer).data("multiple"),
            button: $(uploadContainer).find(".select-file-button"),
        }).on('error', function (event, id, name, errorReason, xhr) {

            // show error
            $(uploadContainer).find('.alert-danger').html('An unknown error occurred during the upload process.').show();

        }).on('upload', function (event, id, name) {

            var $bar = $(uploadContainer).find('.progress-bar');

            // show progress bar
            $bar.show();

            if (typeof ie != 'undefined') {

                if(ie <= 9) {
                    // update text
                    $bar.html('loading...');

                }

            }

            else {

                $bar.html('loading...');

            }

            // hide the dropzone (for singles)
            $(uploadContainer).find(".dropper").hide();

            // show the upload progress bar
            $(uploadContainer).find(".uploading").show();

            // this function does not run at all on ie
        }).on('totalProgress', function (event, totalUploadedBytes, totalBytes) {

            // calculate the completion percentage of the upload
            var progress = parseInt(totalUploadedBytes / totalBytes * 100, 10);

            // find progress bar
            var $bar = $(uploadContainer).find('.progress-bar');

            // set bar width
            $bar.css('width', progress + '%');

            // update text
            $bar.html(progress + '%');

            // upload to server is complete, need to wait for s3 transfer
            if (progress >= 100) {
                $bar.html('Processing...');
            }

        }).on('complete', function (event, id, name, responseJSON) {

            // find progress bar
            var $bar = $(uploadContainer).find('.progress-bar');

            // set bar width and hide
            $bar.css('width', '0%');
            $bar.hide();

            // hide uploading view
            $(uploadContainer).find(".uploading").hide();

            // create the upload confirmation
            $.each(responseJSON.files, function (index, file) {

                // hide dropzone for singles, or show for multiple
                if (!$(uploadContainer).data("multiple")) {
                    $(uploadContainer).find('.dropper').hide();
                    $(uploadContainer).find('.dropper input').attr('disabled','disabled');
                } else {
                    $(uploadContainer).find('.dropper').show();
                }

                // add upload preview
                $(uploadContainer).find('.previews').append(file.preview);

                // remove default input feild (used to set values to '')
                $(uploadContainer).find('.file_id.default').remove();

                // add file id as a hidden field
                $('<input>').attr({
                    type: 'hidden',
                    class: 'file_id',
                    name: $(uploadContainer).data('name'),
                    value: file.id
                }).appendTo(uploadContainer);

            });

        });

        // dropzone
        $(uploadContainer).find(".dropper").fineUploaderDnd({
            classes: {
                dropActive: "active"
            }
        }).on('processingDroppedFiles', function (event) {
            //console.log('processing drop file')
        })
                .on('processingDroppedFilesComplete', function (event, files, dropTarget) {
                    fineuploader.fineUploader('addFiles', files);
                });


    });


    /*
     * Codemirror Editors
     */
    $('.codemirror').each(function (index) {

        // get ref to textarea
        var $textarea = $(this);

        // get id
        var id = $textarea.attr('id');

        // get mode
        var mode = $textarea.data('mode');

        // initialise codemirror
        var editor = CodeMirror.fromTextArea(document.getElementById(id), {
            mode: mode,
            lineNumbers: true,
            lineWrapping: true,
            indentUnit: 4,
            theme: 'monokai'
        });

        // load into text editor
        var content = $('#' + id + '_content').html();

        // set content to editor
        editor.setValue(content);
    });



    /*
     * summernote WYSIWYG Editor (http://hackerwins.github.io/summernote/)
     * NOTE: prepare_summernote() is defined below (outside of 'jquery ready')
     */
    $('.summernote').each(function (index) {

        // get ref to textarea
        var $textarea = $(this);

        // get height based on rows
        var height = $textarea.attr('rows') * 50;

        // initialise summernote
        $textarea.summernote({
            height: height,
            codemirror: {
                theme: 'monokai',
                lineWrapping: true
            },
            toolbar: [
                ['style', ['style', 'bold', 'italic', 'clear']],
                ['para', ['ul', 'ol']],
                ['insert', ['link']],
                ['misc', ['codeview']]
            ]
        });
    });





    $('.mediaTypeCheckbox').click(function() {

        if($(this).val() == "14") {

            if($(this).is(":checked")) {

                $(".newspaper-name-container").removeClass("hidden");

            }

            else {

                $(".newspaper-name-container").addClass("hidden");

            }

        }


        var total_minimum_spend = 0;

        $('.mediaTypeCheckbox:checked').each(function() {

            var minimum_spend = $(this).data('minimum-spend');

            total_minimum_spend += minimum_spend;

        }).bind(total_minimum_spend);

        $("#total_minimum_spend").text(total_minimum_spend);

    });



    $(".is_competition").change(function() {
        var value = $(this).val();
        if(value == 0) {
            $("#tnc_container").hide();
        }
        else {
            $("#tnc_container").show();
        }
    });


    $(".is_offer").change(function() {
        var value = $(this).val();
        if(value == 0) {
            $("#expiry_date_container").hide();
        }
        else {
            $("#expiry_date_container").show();
        }
    });

    $(".social_is_scheduled").change(function() {

        var value = $(this).val();
        if(value == 0) {
            $("#social_schedule_container").hide();
        }
        else {
            $("#social_schedule_container").show();
        }

    });


    $("#marketing-paid-shipping").change(function(){
        var shipping_total = parseFloat($(this).val()).toFixed(2);
        var marketing_product_total = parseFloat($("#marketing-paid-total").text()).toFixed(2);
        var zarraffas_marketing_grand_total = parseFloat(shipping_total) + parseFloat(marketing_product_total);
        $("#zarraffas-marketing-grand-total").text(zarraffas_marketing_grand_total.toFixed(2));
        $("#marketing-paid-shipping").val(shipping_total);
    });


    $("#store-paid-shipping").change(function(){
        var shipping_total = parseFloat($(this).val()).toFixed(2);
        var marketing_product_total = parseFloat($("#store-estimated-total").text()).toFixed(2);
        var zarraffas_marketing_grand_total = parseFloat(shipping_total) + parseFloat(marketing_product_total);
        $("#store-grand-total").text(zarraffas_marketing_grand_total.toFixed(2));
        $("#store-paid-shipping").val(shipping_total);
    });


    $(".is_trailer_booking").change(function() {
        var value = $(this).val();
        if(value == 0) {
            $("#trailer_booking_container").hide();
        }
        else {
            $("#trailer_booking_container").show();
        }
    });


    $(".resource-booking-calendar .available, .resource-booking-calendar .selected").click(function() {
        var resource_id = $(this).data('resource-id');

        var selected_day_index = $(this).data('day-index');

        if($(this).hasClass('disabled')) {
            return false;
        }

        /** number of days selected */
        var total_selected = $(".resource-booking-calendar .selected").length;

        if($(this).hasClass('selected')) {

            $(this).removeClass('selected');

            first_selected_index = null;
            last_selected_index = null;
            $(this).parent().find(".square").each(function(index) {
                if($(this).hasClass("selected") && $(this).hasClass("weekend") == false) {
                    if(first_selected_index == null) {
                        first_selected_index = index;
                    }
                    last_selected_index = index;
                }
            });
            $(this).parent().find(".square").each(function(index) {
                if((index < first_selected_index || index > last_selected_index) && $(this).hasClass('selected')) {
                    $(this).removeClass("selected");
                }
            });


            /**
             * Remove disabled if there are no boxes selected for this row
             */
            var reenable = true;
            $(".resource-booking-calendar .available").each(function() {
                if($(this).data('resource-id') == resource_id && $(this).hasClass('selected'))  {
                    reenable = false;
                }
            });

            if(reenable) {
                $(".resource-booking-calendar .disabled").each(function() {
                    $(this).removeClass("disabled");
                });
            }

            // only one item is now selected, disable the continue button
            if(total_selected == 2) {
                $("#booking_config_daterange_button").attr("disabled", "disabled");
            }

        }

        else {

            $(this).addClass('selected');

            if(total_selected == 0) {

                // special mode to block out everything except the next 6 days
                $(".resource-booking-calendar .available").each(function() {
                    if($(this).data('resource-id') == resource_id) {
                        day_index = $(this).data('day-index');
                        if(day_index < selected_day_index || day_index > selected_day_index+6) {
                            $(this).addClass('disabled');
                        }
                    }
                });

                $("#booking_config_daterange_button").attr("disabled", "disabled");

            }

            else {

                // at least 2 items are selected... re-enable continue button
                $("#booking_config_daterange_button").attr("disabled", false);

                // find the first and last item selected on the row
                first_selected_index = null;
                last_selected_index = null;
                $(this).parent().find(".square").each(function(index) {
                    if($(this).hasClass("selected") && $(this).hasClass("weekend") == false) {
                        if(first_selected_index == null) {
                            first_selected_index = index;
                        }
                        last_selected_index = index;
                    }
                });
                $(this).parent().find(".square").each(function(index) {
                    if(index >= first_selected_index && index <= last_selected_index){
                        $(this).addClass("selected");
                    }
                    else {
                        $(this).removeClass("selected");
                    }
                });


            }

            $(".resource-booking-calendar .available").each(function() {
                if($(this).data('resource-id') != resource_id) {
                    $(this).addClass('disabled');
                }
            });

        }

    });


    if($(".resource-booking-calendar .selected").length > 0) {

        $("#booking_config_daterange_button").attr("disabled", false);

    }


    $("#booking_config_daterange_button").click(function() {

        var selected_dates = [];
        var resource_id = null;

        $(".resource-booking-calendar .selected").each(function(i) {

            resource_id = $(this).data('resource-id');
            selected_dates[i] = $(this).data('date');

        });

        if(selected_dates.length > 7) {
            alert('A booking can not exceed seven days.');
            return false;
        }

        $("#resource_id_input").val(resource_id);
        $("#selected_dates_input").val(selected_dates);
        $("#calendar_form").submit();

    });


});


function fix_it_noaw() {

    $('.face').each(function () {

        $(this).find('img').css({
            width: $(this).parent().width(),
            height: $(this).parent().height(),
            "margin-left": "0px"
        });

    });

}


// delete a file
function delete_file(ref, file_id, formgroup) {

    // get main wrapper
    var container = $(ref).closest('.file-upload-container');

    // remove the link
    $(ref).parent().remove();

    // remove array of file ids
    $(container).find(".file_id[value=" + file_id + "]").remove();

    // remove preview
    container.find('.preview').remove();

    // clear file id
    container.find('input[name=file_id]').val('');

    // show dropzone
    container.find('.dropper').show();

    // hide upload view just in case it still exists
    container.find('.uploading').hide();

    // delete file
    $.post("/files/delete", {file_id: file_id});
}


/*
 * Remove product from draft order
 */
function remove_product(order_id, product_id) {

    // remove row
    $('*[data-product="' + product_id + '"]').remove();

    // remove product
    $.post("/ajax/remove_product", {order_id: order_id, product_id: product_id});

}





/**
 * DataTables internal date sorting replies on `Date.parse()` which is part of
 * the Javascript language, but you may wish to sort on dates which is doesn't
 * recognise. The following is a plug-in for sorting dates in the format
 * `dd/mm/yy`.
 *
 * An automatic type detection plug-in is available for this sorting plug-in.
 *
 * Please note that this plug-in is **deprecated*. The
 * [datetime](//datatables.net/blog/2014-12-18) plug-in provides enhanced
 * functionality and flexibility.
 *
 *  @name Date (dd/mm/YY)
 *  @summary Sort dates in the format `dd/mm/YY`
 *  @author Andy McMaster
 *  @deprecated
 *
 *  @example
 *    $('#example').dataTable( {
 *       columnDefs: [
 *         { type: 'date-uk', targets: 0 }
 *       ]
 *    } );
 */

 jQuery.extend( jQuery.fn.dataTableExt.oSort, {
	"date-uk-pre": function ( a ) {
		if (a == null || a == "") {
			return 0;
		}
		var ukDatea = a.split('/');
		return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
	},

	"date-uk-asc": function ( a, b ) {
		return ((a < b) ? -1 : ((a > b) ? 1 : 0));
	},

	"date-uk-desc": function ( a, b ) {
		return ((a < b) ? 1 : ((a > b) ? -1 : 0));
	}
} );

/**
 * Redirect to URL
 *
 * @param String url URL to redirect to
 */
function redirect(url) {
    window.location.href = url;
}
